import { Sparkles } from 'lucide-react'

export function AuthLoading() {
  return (
    <div className="luxury-mesh flex min-h-full items-center justify-center p-6">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-[hsl(262_70%_48%)] text-white shadow-md">
          <Sparkles className="h-5 w-5 animate-pulse" aria-hidden />
        </div>
        <p className="text-sm text-muted-foreground">Checking your session…</p>
      </div>
    </div>
  )
}
